import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux'
import { privilege } from "../../privilege";
import Filters from '../Filters/Filters'
import { withStyles } from '@material-ui/core/styles';
import Drawer from '@material-ui/core/Drawer';
import Button from '@material-ui/core/Button';
import logo from '../../dp_dok_logo_name-white.svg'
import Divider from '@material-ui/core/Divider';
import Add from '@material-ui/icons/Add';
import FileIcon from '@material-ui/icons/InsertDriveFile';

import { URL_API } from "../../constants";
import {
  changeCharSerial,
  changeDateRange, changeRangeTime, changeSelectModel, changeSelectProducer, changeSelectStatus, changeSelectTech,
  itemsUpdateData,
  modalAction,
  modelTechnics, changeCode,
  producerTechnics, ticketsUrl,
  typeTechnics, clearFilters
} from "../../actions/index";
import { listModelListFilter, clearModelListFilter } from '../../actions/modelList'
import { listStatus } from "../../actions/status";
import { listRepair } from "../../actions/repair";


const styles = theme => ({
  list: {
    width: 300,
  },
  toolbar: theme.mixins.toolbar,
});

class Sidebar extends React.Component {
  constructor(props) {
    super(props)
    // const access = privilege.filter((item) => item.group === this.props.group)

    this.access = (this.props.username === 'admin') ? privilege.group.Admin : privilege.group[this.props.group];
  }
  state = {
    series: "",
    model: "",
    type: "",
    status: '',
    fromDate: null,
    toDate: null,
    producer: '',
    mobileOpen: false,
    code: '',
    clear: false,
    range: '',
    model_list: '',
  };

  componentDidMount() {
    this.props.typeTechnics();
    this.props.producerTechnics();
  }
  componentWillMount() {
    this.props.modelTechnics();
    this.props.actionStatus();
    this.props.actionRepair();
  }

  fetchModelList = (id) => {
    this.props.listModelListFilter(id)
  }

  handleChangeSelect = value => event => {
    this.setState({
      [value]: event.target.value
    });
    if (value === "type") {
      this.props.selectType(event.target.value);
      if (event.target.value !== '') {
        this.fetchModelList(event.target.value)
      } else {
        this.props.clearModelListFilter()
      }
      this.setState({
        model: '',
      })
      this.props.selectModel('')
    }
    if (value === "model") {
      this.props.selectModel(event.target.value);
    }
    if (value === "producer") {
      this.props.selectProducer(event.target.value);
    }
    setTimeout(() => {
      this.checkValue()
    }, 100)
  };

  handelChangeStatus = event => {
    this.setState({
      status: event.target.value
    });
    setTimeout(() => {
      this.checkValue()
    })
    this.props.status(event.target.value);

  }


  handleFromDateChange = (date) => {
    this.setState({
      fromDate: date
    });

    setTimeout(() => {
      if (this.state.toDate === null) {
        this.setState({ toDate: date })
      }

      if (this.state.toDate > this.state.fromDate) {
        this.setState({ toDate: date })
      }
      this.checkValue()
      if (this.state.toDate !== null && this.state.fromDate !== null) {
        this.handleDispatchDate();
        this.checkValue()
      }
    }, 100)
  }

  checkValue = () => {
    const { model, status, type, fromDate, toDate, producer, range, code } = this.state;
    if (model !== "" || type !== "" || code !== "" || producer !== "" || range !== "" || status !== "" || fromDate !== null || toDate !== null) {
      this.setState({
        clear: true
      })
    } else {
      this.setState({
        clear: false
      })
    }

  }
  clearDate = () => {
    this.setState({
      fromDate: null,
      toDate: null
    })
  }

  handleToDateChange = (date) => {
    if (!date) {
      this.clearDate()
    }
    setTimeout(() => {
      if (this.state.fromDate === null) {
        this.setState({ toDate: date, fromDate: date });
      } else {
        this.setState({ toDate: date });
      }

      if (this.state.toDate !== null && this.state.fromDate !== null) {
        this.handleDispatchDate();
      }
    }, 100)
  }

  handleRange = (event) => {
    this.props.rangeTime(event.target.value);
    setTimeout(() => {
      this.setState({
        range: event.target.value
      })
      this.checkValue()

    }, 100)
  }

  handleChangeCode = event => {
    let value = event.target.value;
    this.setState({ code: value })
    this.checkValue()
  }

  handleDispatchDate = () => {
    const { toDate, fromDate } = this.state
    setTimeout(() => {
      let dateto = toDate.format('DD-MM-YYYY');
      let datefrom = fromDate.format('DD-MM-YYYY');
      let range = { to: dateto, from: datefrom }
      this.props.dateRange(range);

    }, 100)
  }

  openModal = () => {
    this.props.openModalDis(true)
  }

  handleReportDialogOpen = () => {
    this.props.handleReportDialog(true)
  }

  handleClearFilter = () => {
    this.setState(prevState => ({
      series: prevState.series = "",
      model: prevState.model = "",
      type: prevState.type = "",
      status: prevState.status = '',
      fromDate: prevState.fromDate = null,
      toDate: prevState.toDate = null,
      producer: prevState.producer = '',
      code: prevState.code = '',
      clear: prevState.clear = false,
      range: prevState.range = ''
    }));
    this.props.actionClearFilter();
    this.props.clearModelListFilter();
  }

  componentWillUpdate(nextProps, nextState) {
    if (this.state.code !== nextState.code) {

      if (nextState.code.length >= 4) {
        nextProps.changeCode(nextState.code)
        // console.log(this.state.code,nextState.code)
      } else {
        nextProps.changeCode('')
      }

    }
    if (this.props.filters !== nextProps.filters) {
      nextProps.fetchData(`${URL_API}/request/?status=${nextProps.filters.selectedStatus}&dep=${nextProps.filters.code}&start_date=${nextProps.filters.dataRange.from}&equip__model=${nextProps.filters.selectedModel}&equip__model__type=${nextProps.filters.selectedTech}&equip__model__producer=${nextProps.filters.selectedProducer}&end_date=${nextProps.filters.dataRange.to}&date_range=${nextProps.filters.rangeTime}`)
    }
  }

  renderBtnNewModal = () => {

    const { classes } = this.props;

    if (this.access.read) {
      return (
        <Button variant="contained" color="secondary" onClick={this.openModal} fullWidth>
          <Add className={classes.leftIcon} /> Заявка
          </Button>
      )
    }
  }

  renderBtnReport = () => {

    const { classes } = this.props;

    if (this.access.read) {
      return (
        <Button variant="contained" color="primary" onClick={this.handleReportDialogOpen} fullWidth>
          <FileIcon className={classes.leftIcon} /> Сформувати звіт
        </Button>
      )
    }
  }

  render() {
    const { classes } = this.props;

    const { sidebar, handleToggle } = this.props

    return (
      <div>
        <Drawer
          open={sidebar}
          onClose={handleToggle}
          variant="temporary"
          ModalProps={{
            keepMounted: true, // Better open performance on mobile.
          }}
        >
          <div
            tabIndex={0}
            role="button"
            className={classes.list}
          >
            <div className={classes.toolbar}>
              <div className="logo-wrapper">
                <img src={logo} style={{ width: '209px', display: 'block', margin: '0 auto' }} alt="" />
              </div>
            </div>
            <Divider />
            <div style={{ padding: '1rem' }}>
              {this.renderBtnNewModal()}
            </div>
            <Filters
              toDate={this.state.toDate}
              fromDate={this.state.fromDate}
              valueModel={this.state.model}
              valueType={this.state.type}
              valueStatus={this.props.filters.selectedStatus}
              valueRange={this.props.filters.rangeTime}
              valueCode={this.state.code}
              valueSeries={this.props.series}
              valueProducer={this.state.producer}
              handleRange={this.handleRange}
              selectModel={this.handleChangeSelect('model')}
              selectType={this.handleChangeSelect('type')}
              selectProducer={this.handleChangeSelect('producer')}
              statusSelect={this.handelChangeStatus}
              handleChangeCode={this.handleChangeCode}
              change={this.handleChange}
              series={this.handleSeries}
              changeFromDate={this.handleFromDateChange}
              changeToDate={this.handleToDateChange}
              techlist={this.props.tech}
              model={this.props.model_list}
              producer={this.props.producer}
              listStatus={this.props.listStatus}
              clearFilterVal={this.state.clear}
              clearFilterAction={this.handleClearFilter}
              disable_model={(this.state.type === '') ? true : false}
            />
          </div>
          <div style={{ padding: '1rem' }}>
            {this.renderBtnReport()}
          </div>
        </Drawer>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    open: state.modalAction,
    tickets: state.tickets,
    tech: state.techlist,
    model: state.modelList,
    producer: state.producerList,
    filters: state.filters,
    series: state.charSerial,
    username: state.auth.username,
    group: state.auth.groups['0'],
    listStatus: state.listStatus,
    model_list: state.model_list_filter,
    auth: state.auth,
  };
};

const mapDispatchToProps = (dispatch) => {

  return {
    openModalDis: (bool) => dispatch(modalAction(bool)),
    typeTechnics: () => dispatch(typeTechnics()),
    modelTechnics: () => dispatch(modelTechnics()),
    producerTechnics: () => dispatch(producerTechnics()),
    status: (value) => dispatch(changeSelectStatus(value)),
    seriesSelect: (value) => dispatch(changeCharSerial(value)),
    selectType: (value) => dispatch(changeSelectTech(value)),
    selectModel: (value) => dispatch(changeSelectModel(value)),
    selectProducer: (value) => dispatch(changeSelectProducer(value)),
    dateRange: (range) => dispatch(changeDateRange(range)),
    rangeTime: (range) => dispatch(changeRangeTime(range)),
    actionStatus: () => dispatch(listStatus()),
    actionRepair: () => dispatch(listRepair()),
    listModelListFilter: (id) => dispatch(listModelListFilter(id)),
    clearModelListFilter: () => dispatch(clearModelListFilter()),
    actionClearFilter: () => dispatch(clearFilters()),
    changeCode: (value) => dispatch(changeCode(value)),
    fetchData: (url, bool = false) => {
      dispatch(itemsUpdateData(url))
      if (bool === false) {
        dispatch(ticketsUrl(url))
      }
    },

  };
};

Sidebar.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(Sidebar));


// WEBPACK FOOTER //
// ./src/components/Main/Sidebar.js